export const rpcErrors = [
    'not authorized',
    'daily request count exceeded',
    'invalid json rpc response',
    "we can't execute this request",
    'your account has been suspended',
    'account suspended, please top up to reenable',
    'your account has been suspended',
    'too many requests, we recommend you to use free api key',
    'origin not allowed',
    'api key disabled',
    'access forbidden'
];
